var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcPinWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "44px",
    height: "52px",
    viewBox: "0 0 44 52",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "01 Icons/ic_pin_faulted_white") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "01-Icons/ic_pin_faulted_white",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3-Copy-2",
    transform: "translate(3.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#000000",
    opacity: 0.180989583,
    cx: 19,
    cy: 45,
    rx: 11,
    ry: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19,0 C29.4934102,0 38,8.5621117 38,19.1240117 C38,25.0361333 35.3346264,30.3216603 31.147379,33.8296292 L20.8160721,44.2282645 C19.8195872,45.2312535 18.1986933,45.236526 17.1957044,44.2400411 L17.1839279,44.2282645 L17.1839279,44.2282645 L6.85262095,33.8296292 C2.66537362,30.3216603 0,25.0361333 0,19.1240117 C0,8.5621117 8.50658975,0 19,0 Z",
    id: "Oval-3",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(10.000000, 7.000000)",
    stroke: "#191919"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.8,
    x: 2,
    y: 3.6,
    width: 13.6,
    height: 17.6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 1.6,
    x: 4.8,
    y: 18.4,
    width: 8,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.8,
    x: 4.4,
    y: 5.2,
    width: 3.2,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.8,
    x: 4.4,
    y: 8.4,
    width: 3.2,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.8,
    x: 10,
    y: 5.2,
    width: 3.2,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.8,
    x: 10,
    y: 8.4,
    width: 3.2,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.8,
    x: 4.4,
    y: 11.6,
    width: 3.2,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.8,
    x: 10,
    y: 11.6,
    width: 3.2,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.8,
    x: 4.4,
    y: 14.8,
    width: 3.2,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.8,
    x: 10,
    y: 14.8,
    width: 3.2,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 1.6,
    x: 0.8,
    y: 2.4,
    width: 16,
    height: 20
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.8,
    x: 0.4,
    y: 0.4,
    width: 4.8,
    height: 1
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPinWhite);
export default __webpack_public_path__ + "static/media/ic-pin-white.05e87753079058e7b0bf2c6c2e66f67b.svg";
export { ForwardRef as ReactComponent };